import { useMemo } from "react"

import useCartContextQuery from "@/queries/hooks/useCartContextQuery"
import useSalePeriodQuery from "@/queries/hooks/useSalePeriodQuery"

const useDateConstraints = (resortExternalId: number) => {
  const { data: cartContext, isLoading: isCartContextLoading } =
    useCartContextQuery(resortExternalId)
  const { data: salePeriod, isLoading: isSalePeriodLoading } =
    useSalePeriodQuery(resortExternalId)

  const maxDate = useMemo(() => {
    if (cartContext?.end && salePeriod?.endDate) {
      if (cartContext.end > salePeriod.endDate) {
        return salePeriod.endDate
      } else {
        return cartContext.end
      }
    }

    return cartContext?.end ?? salePeriod?.endDate
  }, [cartContext?.end, salePeriod?.endDate])

  const minDate = useMemo(() => {
    if (cartContext?.start && salePeriod?.startDate) {
      if (cartContext.start < salePeriod.startDate) {
        return salePeriod.startDate
      } else {
        return cartContext.start
      }
    }
    return cartContext?.start ?? salePeriod?.startDate
  }, [cartContext?.start, salePeriod?.startDate])

  const unAvailableDates = useMemo(
    () => salePeriod?.unAvailableDates ?? [],
    [salePeriod?.unAvailableDates]
  )

  return {
    minDate,
    maxDate,
    unAvailableDates,
    isLoading: isCartContextLoading || isSalePeriodLoading,
  }
}

export default useDateConstraints
